import { Grid } from "@mui/material";
import { Spinner } from "../../../components/Loading/Spinner";
import HeaderObjetivos from "../../../components/Table/OAS/Objetivos/HeaderObjetivos";
import ObjetivosTable from "../../../components/Table/OAS/Objetivos/ObjetivosTable";
import { useObjetivos } from "../../../context/SuperAdmin/OASContexts/ObjetivosContext";
import DeleteObjetivosModal from "../../../components/Table/OAS/Objetivos/DeleteObjetivosModal";
import EditObjetivoModal from "../../../components/Table/OAS/Objetivos/EditObjetivoModal";

const ObjetivosPage = () => {
  const { isLoading } = useObjetivos();

  if (isLoading) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Agregar o eliminar objetivos */}
      <Grid item>
        <HeaderObjetivos />
      </Grid>

      {/* Tabla de objetivos */}
      <Grid item>
        <ObjetivosTable />
      </Grid>

      {/* Modal para confirmar eliminar objetivos de la organización */}
      <Grid item>
        <DeleteObjetivosModal />
      </Grid>

      {/* Modal para editar un objetivo en una organización */}
      <Grid item>
        <EditObjetivoModal />
      </Grid>
    </Grid>
  );
};

export default ObjetivosPage;
